import { configureStore } from "@reduxjs/toolkit";
import untappedSlice from "./transactions/UntappedSlice";

export const store = configureStore({
  reducer: {
    untapped: untappedSlice,
  },
});
